import { FC } from 'react';
import { Wrap, WrapItem } from '@chakra-ui/react';
import { IconName as SunshineIconName } from '@shinetools/sunshine-icons';

import { Maybe, ToolboxTag } from '__generated__/GQL';
import Chip from 'components/_core/Chip';

import locales from './locales';

type TagsListProps = {
  activeTags?: Maybe<string[]>;
  onChange: (newActiveTag: ToolboxTag | null) => void;
  tags?: ToolboxTag[];
};

const TagsList: FC<TagsListProps> = ({ activeTags, onChange, tags }) => {
  const isActive = (tag: ToolboxTag) =>
    activeTags?.includes(tag.toolboxTagId) ?? false;

  const onClearTags = () => onChange(null);
  const onTagClicked = (tag: ToolboxTag) => onChange(tag);

  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Wrap paddingBottom="space-24">
      <WrapItem>
        <Chip icon="eye-open" isActive={!activeTags} onClick={onClearTags}>
          {locales.allTags}
        </Chip>
      </WrapItem>

      {tags.map((tag) => (
        <WrapItem key={tag.toolboxTagId}>
          <Chip
            icon={tag.icon as SunshineIconName}
            isActive={isActive(tag)}
            onClick={() => onTagClicked(tag)}
          >
            {tag.name}
          </Chip>
        </WrapItem>
      ))}
    </Wrap>
  );
};

export default TagsList;
